export enum DiscoverSpecialFolders {
    novice = 'novice',
    intermediate = 'intermediate',
    enthusiast = 'enthusiast',
}

export enum DiscoverTemplates {
    category = 'ContentMainCategory',
    subcategory = 'ContentSubCategory',
    segmentCodes = 'ContentSegmentCode',
    accountListCodes = 'ContentAccountListCode',
}

export enum DiscoverQueryParams {
    account = 'ac',
    segment = 'seg',
    os = 'o',
    gdpr = 'gdpr',
}

export enum ErrorPageType {
    common = 'common',
    noaccess = 'noaccess',
    nolocale = 'nolocale',
    notFound = 'notFound',
    unPublished = 'unPublished',
}
